import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconBadgeComponent } from './icon-badge.component';

@NgModule({
  declarations: [IconBadgeComponent],
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  exports: [IconBadgeComponent],
})
export class IconBadgeModule {}
